import React from 'react';
import { FieldValues } from 'react-hook-form';

import SystemDevice from 'features/systems/domain/models/system-device';
import DomipConfiguration from 'features/systems/domip/domain/models/domip-configuration';
import ReadDomipConfigurationResponse from 'features/systems/domip/domain/models/read-domip-configuration-response';
import CreateDomipDeviceCommand from '../../domain/models/create-domip-device-command';

export type DomipProviderContextType = {
  readDomipConfigurationData: ReadDomipConfigurationResponse | undefined;
  readDomipConfigurationIsLoading: boolean;
  readDomipConfigurationIsFetching: boolean;
  updateDomipConfiguration: (domipConfiguration: DomipConfiguration) => void;
  updateDomipConfigurationIsSuccess: boolean;
  updateDomipConfigurationFromForm: (fieldValues: FieldValues) => void;
  createDomipDevice: (createDomipDeviceCommand: CreateDomipDeviceCommand) => void;
  resetForm: () => void;
  domipPulseNumberHasDevice: (domipPulseNumber: number, outputDevice: boolean) => boolean;
  domipPulseNumberHasLinkedDevice: (domipPulseNumber: number, outputDevice: boolean) => boolean;
  openDeviceDetails: (domipPulseNumber: number, outputDevice: boolean) => void;
  selectedDeviceId: string | undefined;
  getBreadCrumbsForDomipPulseNumber: (domipPulseNumber: number, outputDevice: boolean) => string[];
  getFunctionForDomipOutputPulseNumber: (domipPulseNumber: number) => string | undefined;
  getDomipInputDevicePulseNumber: (domipPulseNumber: number) => SystemDevice | undefined;
};

const DomipProviderContext = React.createContext<DomipProviderContextType>({} as never);

export default DomipProviderContext;
